export default __webpack_public_path__ + "static/media/characters_right.8314a5a2.svg";